module.exports = __webpack_public_path__ + "static/media/d1kz.f2dfbcd2.pdf";